import projection from '../generated/pwg209f1.json';
import { AcceptanceManifest } from '../types';

export const pwg209f1AcceptanceManifest = projection as AcceptanceManifest;
